import { createFileRoute } from '@tanstack/react-router';
import { InvoicePage } from '@/pages/Invoice';
import type { InvoiceDocumentType } from '@/apis/invoices';

export const Route = createFileRoute('/_admin/invoice/')({
  component: InvoicePage,
  validateSearch: (
    search: Record<string, unknown>,
  ): {
    page: number;
    limit?: number;
    search?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    documentType?: InvoiceDocumentType;
  } => ({
    page: typeof search.page === 'number' ? search.page : 1,
    limit: typeof search.limit === 'number' ? search.limit : undefined,
    search: search.search as string | undefined,
    status: search.status as string | undefined,
    startDate: search.startDate as string | undefined,
    endDate: search.endDate as string | undefined,
    // Defaulted, so every existing /invoice link keeps showing invoices.
    documentType:
      search.documentType === 'credit_memo' ? 'credit_memo' : 'invoice',
  }),
});
